import { useMemo } from 'react';
import { useAppStore } from '../store/useAppStore';
import { makeTheme, type Theme } from './theme';

/**
 * Resolves the active theme (light/dark) from the app store into the JS design-system
 * object. Reactive — flips instantly when useAppStore.toggleTheme() runs, on every platform
 * (replaces the web-only `document.documentElement[data-theme]` mechanism).
 */
export function useTheme(): Theme {
  const mode = useAppStore((s) => s.theme);
  return useMemo(() => makeTheme(mode), [mode]);
}
